import type {ControlCardInstanceFullFragment} from "app/gql/graphqlSchema";

export type RefOption = ControlCardInstanceFullFragment["columnRefOptions"][number];
type PossibleRefOptions = RefOption["__typename"];

interface Mapping<T> {
  textExtractor: (item: T) => string;
  filter: (item: T) => boolean;
}

type RefOptionType<T extends RefOption, Key extends PossibleRefOptions> = Extract<
  T,
  {__typename: Key}
>["options"][number];

export type RefOptionsMapping<T extends RefOption> = {
  [Key in PossibleRefOptions]: Mapping<RefOptionType<T, Key>>;
};

export const refMapping: RefOptionsMapping<RefOption> = {
  EmployeeColumnRefOptions: {
    textExtractor: (item) => item.employee.name,
    filter: (item) => !item.employee.disabled
  }
};
